/**
 * Feature Flags Configuration
 * 
 * REACTIVATION CODE: NEXBLUE_ZEN_SENSOR_2024
 * 
 * To reactivate the NexBlue Zen Strømsensor feature:
 * Tell the assistant: "Reactivate feature with code NEXBLUE_ZEN_SENSOR_2024"
 * 
 * This will set FEATURE_NEXBLUE_SENSOR to true
 */

// ========================================
// FEATURE FLAGS
// ========================================

// NexBlue Zen Strømsensor feature - set to false to hide all sensor-related UI
export const FEATURE_NEXBLUE_SENSOR = false;

// Tænk Test Banner - set to false to hide ALL Tænk banners across the site in one go
export const FEATURE_TAENK_BANNER = false;

// ========================================
// SOLAR / SOLCELLEAFTALE (production agreement)
// REACTIVATION CODE: SOLAR_PRODUCTION_2026
// To bring solar back everywhere, tell the assistant:
// "Reactivate feature with code SOLAR_PRODUCTION_2026"
// ========================================
// Master switch for ALL solar/production-agreement offering on the site:
// - /solcelleaftale, /en/solar-agreement pages (show "paused" notice instead)
// - Solar links in DA + EN burger menus
// - Solar add-on toggles in all 4 checkouts (NyCheckout, NyCheckoutV2, DetailedCheckout, EnNyCheckout)
// - Solar add-ons in Loesning/Loesning2 configurators
// - Solar FAQ sections (Supportkundeportal DA + EnSupport EN)
// NOTE: redirect/tracking functions still accept subscription_solar params (untouched by design).
// Remember when flipping back: re-add /solcelleaftale + /en/solar-agreement in the sitemap
// function, and re-activate the AI assistant policy + cached answers about solar.
export const FEATURE_SOLAR = false;

// ========================================
// END FEATURE FLAGS
// ========================================